export default __webpack_public_path__ + "static/sectorPoniente-41f4f6bedd29281c299d4abe0caacae2.webp";